import { Component, Input, OnInit, QueryList, ViewChildren } from '@angular/core';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Coe } from 'src/app/component/coe/model/coe.model';
import { CleanDatePipe } from 'src/app/pipes/clean-date.pipe';
import { GetPropertyPipe } from 'src/app/pipes/get-property.pipe';
import { SimpleDatePipe } from 'src/app/pipes/simple-date.pipe';
import { StudentService } from '../../service/student.service';

@Component({
    selector: 'view-child-move-history',
    templateUrl: './view-child-move-history.component.html',
    styleUrl: './view-child-move-history.component.scss'
})
export class ViewChildMoveHistoryComponent implements OnInit {
    @Input() studentId!: number;

    coes: Coe[] = [];

    isLoading: boolean = false;
    promises: Array<any> = [];

    getPropertyPipe = new GetPropertyPipe();
    cleanDatePipe = new CleanDatePipe();
    simpleDatePipe = new SimpleDatePipe();

    // Table display
    coeDisplayedColumns: string[] = [
        'COE_PARTY_ROLES[0].PARTY_ROLES.PARTy.ORGANIZATIONS[0].REGIONS[0].CODE',
        'COE_NUMBER',
        'NODE_COES[0].NODE',
        'NODE_COES[0].NODE.NODE_HISTORIES[coe.NODE_COES[0].NODE.NODE_HISTORIES.length - 1].CREATED_DATE',
        'COE_MOVEMENT_INFORMATION[0].CITy.CITY_NAME',
        'COE_MOVEMENT_INFORMATION[1].CITy.CITY_NAME',
        'COE_MOVES[0].RESIDENCY_DATE',
        'QUALIFYING_ARRIVAL_DATE'
    ];

    // Table results
    @ViewChildren(MatSort) sorts: QueryList<MatSort> = new QueryList<MatSort>();
    regions: any[] = [];
    coeTableDataSource: MatTableDataSource<Coe>;

    constructor(private studentService: StudentService) {}

    ngOnInit(): void {
        this.init();
    }

    init() {
        this.isLoading = true;

        this.getCoesDetailed();

        Promise.all(this.promises).then((res) => {
            this.updateDataSource();

            this.isLoading = false;
        });
    }

    getCoesDetailed() {
        let deferred = new Promise((resolve, reject) => {
            this.studentService.getCoesDetailed(this.studentId).subscribe((res) => {
                if (res.coes) {
                    this.coes = res.coes;

                    resolve(res);
                } else if (res?.msg) {
                    resolve(res);
                } else {
                    reject('err');
                }
            });
        });

        this.promises.push(deferred);
    }

    updateDataSource() {
        setTimeout(() => {
            // Data
            this.coeTableDataSource = new MatTableDataSource<Coe>();
            this.coeTableDataSource.data = this.coes;

            // Paginator
            //this.coeTableDataSource.paginator = this.paginators.toArray()[0];

            // Sort
            this.coeTableDataSource.sort = this.sorts.toArray()[0];
            const defaultSort: Sort = { active: 'COE_MOVES[0].RESIDENCY_DATE', direction: 'desc' };
            this.coeTableDataSource.sort.active = defaultSort.active;
            this.coeTableDataSource.sort.direction = defaultSort.direction;
            this.coeTableDataSource.sort.sortChange.emit(defaultSort);
            this.coeTableDataSource.sortingDataAccessor = (obj, property) => this.getPropertyPipe.transform(obj, property, true);

            // Filter
            this.coeTableDataSource.filterPredicate = (data: any, filter) => {
                const dataStr = JSON.stringify(data).toLowerCase();
                return dataStr.indexOf(filter) != -1;
            };

            setTimeout(() => {
                this.coeTableDataSource.sort?.sortChange.emit(defaultSort);
            });
        });
    }

    generateUpdatedTooltip(node: any) {
        let index = this.coes.findIndex((coe) => coe.NODE_COES[0].NODE.ID === node.ID);

        if (index >= 0) {
            this.coes[index].UPDATED_TOOLTIP = 'Updated by NAME (USER_NAME) on DATE';

            if (
                this.coes[index].NODE_COES[0].NODE.NODE_HISTORIES[this.coes[index].NODE_COES[0].NODE.NODE_HISTORIES.length - 1].LOGIN_DETAILS.USER_ID !==
                'admin'
            ) {
                this.coes[index].UPDATED_TOOLTIP = this.coes[index].UPDATED_TOOLTIP.replace(
                    'NAME',
                    this.coes[index].NODE_COES[0].NODE.NODE_HISTORIES[this.coes[index].NODE_COES[0].NODE.NODE_HISTORIES.length - 1].LOGIN_DETAILS.PERSON
                        .FIRST_NAME +
                        ' ' +
                        this.coes[index].NODE_COES[0].NODE.NODE_HISTORIES[this.coes[index].NODE_COES[0].NODE.NODE_HISTORIES.length - 1].LOGIN_DETAILS.PERSON
                            .LAST_NAME
                );
                this.coes[index].UPDATED_TOOLTIP = this.coes[index].UPDATED_TOOLTIP.replace(
                    'USER_NAME',
                    this.coes[index].NODE_COES[0].NODE.NODE_HISTORIES[this.coes[index].NODE_COES[0].NODE.NODE_HISTORIES.length - 1].LOGIN_DETAILS.USER_ID
                );
            } else {
                this.coes[index].UPDATED_TOOLTIP = this.coes[index].UPDATED_TOOLTIP.replace('by NAME (USER_NAME) ', '');
            }
            this.coes[index].UPDATED_TOOLTIP = this.coes[index].UPDATED_TOOLTIP.replace(
                'DATE',
                this.simpleDatePipe.transform(
                    this.cleanDatePipe.transform(
                        this.coes[index].NODE_COES[0].NODE.NODE_HISTORIES[this.coes[index].NODE_COES[0].NODE.NODE_HISTORIES.length - 1].CREATED_DATE
                    )
                )
            );
        }
    }
}
